<script setup lang="ts">

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="w-full h-auto"
       viewBox="0 0 202.624 176.132">
    <g clip-path="url(#clip-path)">
      <path
          d="M35.839,0l130.72.079,1.4.724,34.517,41.571.149,1.944L102.83,175.287c-1.6,1.646-2.635.6-3.881-.716L0,44.893l.176-3.05C10.523,30.195,19.854,17.669,30.1,5.936,31.155,4.722,34.706.253,35.839,0M94.691,4.88H40.9l20,34.677Zm66.89,0H107.432l34.324,34.684Zm-25.836,36.1L100.933,6.321,66.378,40.979Zm-80.339,0L35.592,7,7.628,40.979Zm139.088,0L166.186,7l-19.47,33.975Zm-135.9,5.309H7.628l83.7,109.723,1.238-1.256Zm79.985,0H63.9l37.334,117.856Zm56.272,0H144.062L110.443,152.111l-.553,3.3,1.272.573Z"/>
    </g>
  </svg>

</template>

<style scoped>

</style>